import { UPDATE_PASSWORD } from './ApiConstants';
import api from './ApiHandler';

export const getUserUpdate = async ({
  oldPassword,
  newPassword,
  confirmPassword
}: {
  oldPassword: String;
  newPassword: String;
  confirmPassword: String;
}) => {
  return await api.post(UPDATE_PASSWORD, {
    oldPassword,
    newPassword,
    confirmPassword
  });
};
